import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ActiveControl from '../../../../components/ActiveControl';

import { ProductDataForm, ProductFilters } from '../../../../app/models/Product';
import ProductSwitchChange from '../ProductSwitchChange';
import ProductFilter from './ProductFilter';

interface Props {
  products: ProductDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  showRecipe?: (id: number) => void;
  cloneFrom?: (id: number) => void;
  active?: (id: number, active: boolean) => void;
  show?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: ProductFilters;
  setFilter: (filter: ProductFilters) => void;
  paginationRowsPerPageOptions?: any[];
  callbackSuccess: () => void;
  onSearch: () => void;
}

const ProductDataTable = ({
  products, totalRows, loading = false, edit, showRecipe, cloneFrom, destroy, active, show,
  filter, setFilter, callbackSuccess, onSearch
}: Props) => {

  const columns = [
    {
      name: 'Id',
      selector: (row: any) => row.id,
      sortable: true,
      sortField: 'id',
      width: '80px',
      cell: (row: ProductDataForm) => <span>{row.id}</span>
    },

    {
      name: 'Nombre',
      selector: (row: any) => row.name,
      sortable: true,
      sortField: 'name',
      minWidth: '320px',
      width: '320px',
      cell: (row: ProductDataForm) => (
        <span>{row.name}</span>
      )
    },

    { name: 'Sector', selector: (row: any) => row.sector, sortable: true, sortField: 'sector',
      cell: (row: ProductDataForm) => <span>{row.sector}</span> },

    { name: 'Categoría', selector: (row: any) => row.category, sortable: true, sortField: 'category',
      cell: (row: ProductDataForm) => <span>{row.category}</span> },

    { name: 'Propiedad', selector: (row: any) => row.ownership_type_label ?? row.ownership_type,
      sortable: true, sortField: 'ownership_type',
      cell: (row: ProductDataForm) => <span>{row.ownership_type_label ?? row.ownership_type}</span> },

    { name: 'Unidad', selector: (row: any) => row.unit, sortable: true, sortField: 'unit__name',
      cell: (row: ProductDataForm) => <span>{(row as any).unit}</span> },

    { name: 'Activo', selector: (row: any) => row.is_active, sortable: true, sortField: 'is_active',
      cell: (row: ProductDataForm) => (
        <ProductSwitchChange
          checkValue={row.is_active ?? true}
          productId={row.id!}
          callbackSuccess={callbackSuccess}
        />
      )
    },

    {
      name: 'Acciones', selector: (row: any) => row.id, sortable: false,
      cell: (row: ProductDataForm) => (
        <div>
          {show && (
            <ButtonTableAction
              callbackFunction={() => show(row.id ?? -1)}
              classIcon="mdi mdi-eye"
              colorIcon="text-info"
              title="Ver"
            />
          )}
          {edit && (
            <ButtonTableAction
              callbackFunction={() => edit(row.id ?? -1)}
              classIcon="mdi mdi-pencil"
              colorIcon="text-warning"
              title="Editar"
            />
          )}
          {showRecipe && (
            <ButtonTableAction
              callbackFunction={() => showRecipe(row.id ?? -1)}
              classIcon="mdi mdi-format-list-bulleted"
              colorIcon="text-secondary"
              title="Receta"
            />
          )}
          {cloneFrom && (
            <ButtonTableAction
              callbackFunction={() => cloneFrom(row.id ?? -1)}
              classIcon="mdi mdi-content-copy"
              colorIcon="text-primary"
              title="Nuevo producto desde este"
            />
          )}
          {destroy && (
            <ButtonTableAction
              callbackFunction={() => destroy(row.id ?? -1)}
              classIcon="mdi mdi-delete"
              colorIcon="text-danger"
              title="Eliminar"
            />
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <ProductFilter filter={filter} setFilter={setFilter} onSearch={onSearch} />
        </div>
      </div>

      <DefaultDataTable
        columns={columns}
        data={products}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default ProductDataTable;
